"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromStorage = exports.storageKeys = exports.setStorageValue = exports.getStorageValue = exports.cleanStorage = void 0;
const aes_1 = __importDefault(require("crypto-js/aes"));
const enc_utf8_1 = __importDefault(require("crypto-js/enc-utf8"));
const constants_1 = require("../assets/constants/constants");
const storageKeys = {
    user: {
        token: 'PORTAL360:user_token',
        role: 'PORTAL360:user_role',
        personalData: 'PORTAL360:user_personal_data',
        tokenPowerbi: 'PORTAL360:user_token_powerbi',
        expirationTokenPowerbi: 'PORTAL360:user_token_expiration_powerbi',
    },
};
exports.storageKeys = storageKeys;
const encrypt = (value) => aes_1.default.encrypt(value, constants_1.ENCRYPTION_KEY).toString();
const decrypt = (value) => {
    if (value) {
        return aes_1.default.decrypt(value, constants_1.ENCRYPTION_KEY).toString(enc_utf8_1.default);
    }
    return null;
};
const removeFromStorage = (storageKey) => {
    localStorage.removeItem(storageKey);
};
exports.removeFromStorage = removeFromStorage;
const cleanStorage = () => {
    Object.keys(storageKeys).forEach((storageSection) => {
        Object.values(storageKeys[storageSection]).forEach((storageValue) => {
            localStorage.removeItem(storageValue);
        });
    });
};
exports.cleanStorage = cleanStorage;
const setStorageValue = (value, key) => localStorage.setItem(key, encrypt(value));
exports.setStorageValue = setStorageValue;
const getStorageValue = (key) => decrypt(localStorage.getItem(key));
exports.getStorageValue = getStorageValue;
